import type { ButtonHTMLAttributes, ReactNode } from "react";

const baseClassName =
  "inline-flex items-center gap-3 font-sans font-medium tracking-tight transition-colors duration-200 rounded-xs disabled:cursor-not-allowed disabled:opacity-50";

const variantClassNames = {
  primary: "bg-accent px-6 py-3.5 text-paper hover:bg-accent-deep",
  secondary:
    "border border-ink px-6 py-3.5 text-ink hover:bg-ink hover:text-paper",
  ghost:
    "px-0 py-0 text-ink underline underline-offset-4 hover:decoration-dotted",
} as const;

export type ButtonVariant = keyof typeof variantClassNames;

function joinClassNames(...values: Array<string | undefined>) {
  return values.filter(Boolean).join(" ");
}

export function buttonClasses(variant: ButtonVariant = "primary", className?: string) {
  return joinClassNames(baseClassName, variantClassNames[variant], className);
}

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: ButtonVariant;
};

export function Button({
  children,
  className,
  type = "button",
  variant = "primary",
  ...props
}: ButtonProps) {
  return (
    <button className={buttonClasses(variant, className)} type={type} {...props}>
      {children}
    </button>
  );
}
